import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, BehaviorSubject, Subject} from 'rxjs';
import {Commodity} from '../../pages/settings/commodity/commodity.model';

export interface CommodityRequestParam {
    id: number;
    name: string;
 }

@Injectable()
export class CommodityService {

    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig) {
    }
    // fetch All Commodity
    getAllCommodity(): Observable<any> {
        const me = this;
        const commodityListSubject = new Subject<any>(); // Will use this subject to emit data that we want
        me.apiRequest.get(this.appConfig.commodity_url).subscribe(jsonResp => {
            const items = jsonResp.data.map(function (v) {
                return Object.assign({}, v, {
                    id: `${v.id}`,
                    name: `${v.name}`,
                  });
            });

            const commodityObj = Object.assign({}, jsonResp, {
                data: items
            });
           commodityListSubject.next(commodityObj); // incidentList is a Subject and emits an event thats being listened to by the components
        });
        return commodityListSubject;
    }
    // save commodity
    save(commodity: Commodity): Observable<any> {
        const me = this;

        const bodyData: CommodityRequestParam = <CommodityRequestParam> {
            'name': commodity.name

        };

        const commodityDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.post(this.appConfig.commodities_url, bodyData)
            .subscribe(jsonResp => {
                    let commodityInfoReturn: CommodityRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const commodity: Commodity = jsonResp.data[0];

                        commodityInfoReturn = <CommodityRequestParam>{
                           'name': commodity.name
                        };

                    } else {
                        console.log('added:----:' + jsonResp.message);
                    }
                    commodityDataSubject.next(commodityInfoReturn);
                },
                err => {
                    console.log('added err:----:' + err);
                });

        return commodityDataSubject;
    }
    // update commodity
    update(commodity: Commodity, id: number): Observable<any> {
        const me = this;

        const bodyData = {
            'id': commodity.id,
            'name': commodity.name
        };

        const commodityDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.put(this.appConfig.commodities_url + '/' + id, bodyData)
            .subscribe(jsonResp => {
                    let commodityInfoReturn: CommodityRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const cc: Commodity = jsonResp.data[0];
                        commodityInfoReturn =  <CommodityRequestParam> {
                            'id': cc.id,
                            'name': cc.name,
                        };

                    } else {
                        console.log('updated :----:' + jsonResp.message);
                    }
                    commodityDataSubject.next(commodityInfoReturn);
                },
                err => {
                    console.log('update  err:----:' + err);
                });

        return commodityDataSubject;
    }

    deleteCommodity(id: number): Observable<any> {
        const me = this;
        return me.apiRequest.delete(this.appConfig.commodities_url + '/' + id);
    }

    getCommodityDD(): Observable<any> {
        const me = this;
        return me.apiRequest.get(this.appConfig.commodity_url);
    }

}

